export const blockServices = {
  protocol: "protocol",
  iptype_single: "filter_ip_single",
  iptype_range: "filter_ip_range",
  iptype_all: "filter_ip_all",
  single_ip_prefix: "f_pcip",
  range_start_prefix: "f_startip",
  range_end_prefix: "f_endip",
};

export default blockServices;
